import type { EffectBuild, EffectDesignsState } from "../../../schemas/index.ts";
import { extractNodeValueRefIds, extractRefIds } from "../../../shared/index.ts";

interface Options {
  effectsState: EffectDesignsState;
}

export type EffectBuildsQuery =
  | {
      type: "byId";
      effectId: number;
    }
  | {
      type: "byResponseId";
      responseId: number;
    }
  | {
      type: "referencingNodeId";
      nodeId: number;
    };

export const queryEffectBuildsCreate =
  ({ effectsState: { idsByResponseId, byId } }: Options) =>
  (query: EffectBuildsQuery): EffectBuild[] => {
    switch (query.type) {
      case "byResponseId": {
        return (idsByResponseId[query.responseId] ?? []).map((id): EffectBuild => ({ id, ...byId[id] }));
      }

      case "byId": {
        const id = query.effectId;
        const effectBuild = byId[id];
        if (!effectBuild) return [];
        return [{ id, ...effectBuild }];
      }

      case "referencingNodeId": {
        const { nodeId } = query;
        return Object.entries(byId)
          .filter(
            ([_, effectBuild]) =>
              extractRefIds(effectBuild.config.refs).includes(nodeId) ||
              extractNodeValueRefIds(effectBuild.config).includes(nodeId),
          )
          .map(([id, effectBuild]) => ({ id: Number(id), ...effectBuild }));
      }

      default:
        // @ts-expect-error missed case
        throw new Error(`Unsupported query type: ${query.type}`);
    }
  };

export type QueryEffectBuilds = ReturnType<typeof queryEffectBuildsCreate>;
